import * as actions from './actions';

const initialState = {
  // Free simple
  simpleReading: null,
  simpleLoading: false,
  simpleError: null,
  simpleLiked: false,

  // Premium reading (paid OR perk SU) — pasa por revisión humana 20h
  premiumData: null,
  premiumLoading: false,
  premiumPending: false,
  premiumEtaAt: null,
  premiumError: null,

  // Perk-SU deep reading submission
  deepRequestLoading: false,
  deepRequestReadingId: null,
  deepRequestError: null,

  // Anonymous per-reading purchase
  pendingReadingId: null,
  pendingLoading: false,
  checkoutLoading: false,
  checkoutError: null,
  purchaseVerified: false,
  paidReadingId: null,
  paidEmail: null,
};

export default function suenosReducer(state = initialState, action) {
  switch (action.type) {
    // --- simple ---
    case actions.INTERPRET_SIMPLE_REQUEST:
      return { ...state, simpleLoading: true, simpleError: null, simpleReading: null };
    case actions.INTERPRET_SIMPLE_SUCCESS:
      return { ...state, simpleLoading: false, simpleReading: action.payload.reading };
    case actions.INTERPRET_SIMPLE_FAILURE:
      return { ...state, simpleLoading: false, simpleError: action.payload.error };
    case actions.RESET_SIMPLE:
      return { ...state, simpleReading: null, simpleError: null, simpleLiked: false };
    case actions.SET_SIMPLE_LIKE_SUCCESS:
      return { ...state, simpleLiked: true };

    // --- premium fetch ---
    case actions.PREMIUM_REQUEST:
      return {
        ...state,
        premiumLoading: true, premiumPending: false, premiumEtaAt: null,
        premiumError: null,
      };
    case actions.PREMIUM_SUCCESS:
      return {
        ...state,
        premiumData: action.payload.data,
        premiumLoading: false, premiumPending: false, premiumError: null,
      };
    case actions.PREMIUM_PENDING:
      return {
        ...state,
        premiumPending: true, premiumEtaAt: action.payload.etaAt,
        premiumData: null, premiumLoading: false, premiumError: null,
      };
    case actions.PREMIUM_FAILURE:
      return { ...state, premiumLoading: false, premiumError: action.payload.error };

    // --- perk-SU request ---
    case actions.REQUEST_DEEP_READING_REQUEST:
      return { ...state, deepRequestLoading: true, deepRequestError: null, deepRequestReadingId: null };
    case actions.REQUEST_DEEP_READING_SUCCESS:
      return { ...state, deepRequestLoading: false, deepRequestReadingId: action.payload.readingId };
    case actions.REQUEST_DEEP_READING_FAILURE:
      return { ...state, deepRequestLoading: false, deepRequestError: action.payload.error };

    // --- anonymous purchase ---
    case actions.CREATE_PENDING_DEEP_REQUEST:
      return { ...state, pendingLoading: true, pendingReadingId: null };
    case actions.CREATE_PENDING_DEEP_SUCCESS:
      return { ...state, pendingLoading: false, pendingReadingId: action.payload.readingId };
    case actions.CREATE_PENDING_DEEP_FAILURE:
      return { ...state, pendingLoading: false, checkoutError: action.payload };

    case actions.SUENOS_CHECKOUT_REQUEST:
    case actions.SUENOS_PAYPAL_REQUEST:
      return { ...state, checkoutLoading: true, checkoutError: null };
    case actions.SUENOS_CHECKOUT_SUCCESS:
    case actions.SUENOS_PAYPAL_SUCCESS:
      return { ...state, checkoutLoading: false };
    case actions.SUENOS_CHECKOUT_FAILURE:
    case actions.SUENOS_PAYPAL_FAILURE:
      return { ...state, checkoutLoading: false, checkoutError: action.payload };

    case actions.SUENOS_VERIFY_REQUEST:
    case actions.SUENOS_VERIFY_PAYPAL_REQUEST:
      return { ...state, premiumLoading: true, checkoutError: null };
    case actions.SUENOS_VERIFY_SUCCESS:
    case actions.SUENOS_VERIFY_PAYPAL_SUCCESS:
      return {
        ...state,
        premiumLoading: false,
        purchaseVerified: true,
        paidReadingId: action.payload.reading_id,
        paidEmail: action.payload.email,
      };
    case actions.SUENOS_VERIFY_FAILURE:
    case actions.SUENOS_VERIFY_PAYPAL_FAILURE:
      return { ...state, premiumLoading: false, checkoutError: action.payload };

    default:
      return state;
  }
}
